module.exports = __webpack_public_path__ + "img/cta_hover.8e790010.svg";